import { useContext } from 'react'
import { trackEvent } from 'utils'
import ActionButtons, { ActionButtonContainer } from '../components/ActionButtons'
import Layout from '../components/Layout'
import { SessionContext } from '../components/providers'
import { SView } from '../components/scaled'
import { EXPLORER_DIMENSIONS } from '../utils/helpers'
import { useResultBackground, useResultLayout } from '../utils/resultUtils'
import { useDefaultBackground } from '../utils/traitUtils'

const { height, width } = EXPLORER_DIMENSIONS.layout

export default function ResultView() {
  const { updateRouteSteps, routeSteps } = useContext(SessionContext)
  const defaultBackground = useDefaultBackground()
  const background = useResultBackground()

  const layout = useResultLayout()
  if (!layout) return null

  function handleBack() {
    trackEvent('Layout Back')
    updateRouteSteps(routeSteps.slice(0, -1))
  }

  return (
    <SView
      flex={1}
      align="center"
      justify="center"
      backgroundImage={`url(${background?.url || defaultBackground})`}
      backgroundSize="cover"
    >
      <SView position="absolute" inset={0} backdropFilter="blur(10px)" />

      <SView gap={15}>
        <ActionButtonContainer />
        <SView h={height} w={width}>
          <Layout {...layout} style={{ ...layout?.style, grow: 1 }} />
        </SView>
        <ActionButtons onBack={handleBack} />
      </SView>
    </SView>
  )
}
